import { MenuItem } from '@mui/material'
import { ActionsItemProps } from './actions'
import VerifiedIcon from '@mui/icons-material/Verified'
import { useSendSignedProposalStore } from 'modules/orders/components/sendSignedProposal'

export const SendSignedProposal = ({ order, disabled }: ActionsItemProps) => {
  const setIsProofPaymentModalOpen =
    useSendSignedProposalStore.useSetModalOpen()
  const setProposalId = useSendSignedProposalStore.useSetProposalId()

  const handleClick = () => {
    setIsProofPaymentModalOpen(true)
    setProposalId(order?.proposalId)
  }

  return (
    <MenuItem onClick={handleClick} disabled={disabled}>
      <VerifiedIcon />
      Anexar orçamento assinado
    </MenuItem>
  )
}
